import { render, staticRenderFns } from "./tSystem.vue?vue&type=template&id=500cfa0a&scoped=true"
import script from "./tSystem.vue?vue&type=script&lang=js"
export * from "./tSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500cfa0a",
  null
  
)

export default component.exports